<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import VueCookie from "vue-cookie";
import chroma from "chroma-js";
import Cons from "@/constants.json";

export default {
  mounted() {
    if (process.env.VUE_APP_DEV_ECOSYSTEM != this.$route.params.brandSlug) {
      document.querySelectorAll('[rel="manifest"]')[0].setAttribute('href',process.env.VUE_APP_API  + 'manifest/file');
    }
    this.$Loading.config({
      color: "#000000",
      failedColor: "#f0ad4e",
      height: 5
    });
    // this.$store.dispatch('branding/fetchAppTheme')

    // if (!this.getTheme) return
    //   this.initTheme(this.getTheme)

    // this.loadTheme();
  },
  computed: {
    ...mapGetters("user", ["getTheme", "isLoadingBrandTheme"]),
    isGuest() {
      return this.$store.state.user.info.user_type === "guest";
    }
  },
  methods: {
    ...mapActions('user', ["getBrandCategoriesItem"]),
    loadTheme() {
      let theme = JSON.parse(localStorage.getItem(Cons[0].PATHS.NAME + "THEME"));
      this.initTheme(theme);
    },
    colorTransition(cssVariable, from, to) {
      chroma
        .bezier([from, to])
        .scale()
        .colors(500)
        .forEach(color =>
          document.documentElement.style.setProperty(cssVariable, color)
        );
    },
    initTheme(v){
      this.colorTransition(
        "--toolbar-title-color",
        "#ffffff",
        v && v.toolbar_title_color ? v.toolbar_title_color : "#ffffff"
      );
      this.colorTransition(
        "--toolbar-back-button-color",
        "#3f3c40",
        v && v.toolbar_back_button_color
          ? v.toolbar_back_button_color
          : "#3f3c40"
      );
      this.colorTransition(
        "--toolbar-menu-button-color",
        "#3f3c40",
        v && v.toolbar_menu_button_color
          ? v.toolbar_menu_button_color
          : "#3f3c40"
      );
      this.colorTransition("--toolbar-menu-badge-color", "#ffffff", "#ff3300");
      this.colorTransition(
        "--toolbar-color",
        "#ffffff",
        v && v.toolbar_background_color ? v.toolbar_background_color : "#ffffff"
      );

      this.colorTransition('--primary-color', '#224e95', (v && v.theme_primary_color) ? v.theme_primary_color : '#224e95')
      this.colorTransition('--link-color', '#224e95', (v && v.theme_link_color) ? v.theme_link_color : '#224e95')
      this.colorTransition('--info-color', '#2db7f5', (v && v.theme_info_color) ? v.theme_info_color : '#2db7f5')
      this.colorTransition('--error-color', '#ff3300', (v && v.theme_error_color) ? v.theme_error_color : '#ff3300')
      this.colorTransition('--success-color', '#00cc66', (v && v.theme_success_color) ? v.theme_success_color : '#00cc66')
      this.colorTransition('--warning-color', '#ff9900', (v && v.theme_warning_color) ? v.theme_warning_color : '#ff9900')

      this.colorTransition('--bottom-background-color', '#ffffff', (v && v.bottom_background_color) ? v.bottom_background_color : '#ffffff')
      this.colorTransition('--bottom-icon-color', '#333333', (v && v.bottom_icon_color) ? v.bottom_icon_color : '#333333')
      this.colorTransition('--bottom-icon-highlight-color', '#224e95', (v && v.bottom_icon_highlight_color) ? v.bottom_icon_highlight_color : '#224e95')

      document.documentElement.style.setProperty(
        "--link-hover-color",
        chroma(
          v && v.theme_link_color ? v.theme_link_color : "#224e95"
        ).brighten(0.2)
      );
      document.documentElement.style.setProperty(
        "--link-active-color",
        chroma(v && v.theme_link_color ? v.theme_link_color : "#224e95").darken(
          0.2
        )
      );
      document.documentElement.style.setProperty(
        "--selected-color",
        chroma(
          v && v.theme_primary_color ? v.theme_primary_color : "#224e95"
        ).brighten(0.9)
      );
    },
    initResourceIds(data) {
      if (data) {
        if (data.about_app) {
          Cons[0].MENU_COMPONENT.about_us = data.about_app;
        }
        if (data.about_us) {
          Cons[0].MENU_COMPONENT.about_sharpen = data.about_us;
        }
        if (data.contact_us) {
          Cons[0].MENU_COMPONENT.contact_us = data.contact_us;
        }
      }
    }
  },
  watch: {
    isLoadingBrandTheme: function(n, o) {
      // console.log("Brand isLoadingBrandTheme: ", n);
      if (!n) this.loadTheme();
    },
    $route: function(n, o) {
      if (n != o && "brandSlug" in n.params && n.params.brandSlug) {
        if (n.params.brandSlug !== o.params.brandSlug) {
          Cons[0].PATHS.BRAND = o.params.brandSlug + "_" || "GENERIC_";
          this.$store
            .dispatch("user/getUserBrandInfo", n.params.brandSlug)
            .then(res => {
              if (process.env.VUE_APP_DEV_ECOSYSTEM != this.$route.params.brandSlug) {
                document.querySelectorAll('[rel="manifest"]')[0].setAttribute('href', process.env.VUE_APP_API  + 'manifest/file?brand_id=' + res.id);
              }else{
                document.querySelectorAll('[rel="manifest"]')[0].setAttribute('href', '/manifest.json');
              }
              this.initResourceIds(res.resource_id);
              this.getBrandCategoriesItem({globalResourceId:res.global_resource, networkResourceId:res.network_resource, resourceId:res.resource_id})
            });
        }
      }
    }
  }
};
</script>

<style lang="scss">
@import "assets/scss/app";
</style>
